import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Menu from "./pages/Menu";
import CustomizeCake from "./pages/CustomizeCake";
import Layout from "./Layout";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import AdminDashboard from "./pages/AdminDashboard";
import { createTheme } from "@mui/material/styles";
import { ThemeProvider } from "@mui/material";
import UserProfile from "./pages/UserProfile";
import RegisterPage from "./pages/RegisterPage";
import LoginPage from "./pages/LoginPage";
import About from "./pages/About";
import ConfirmPage from "./pages/ConfirmPage";
import Cake from "./pages/Cake";

const theme = createTheme({
  palette: {
    primary: {
      main: "#ff69b4",
    },
    secondary: {
      main: "#9b2226",
    },
  },
  typography: {
    fontFamily: "Arial, sans-serif",
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="menu" element={<Menu />} />
            <Route path="cart" element={<Cart />} />
            <Route path="checkout" element={<Checkout />} />
            <Route path="about" element={<About />} />
            <Route path="admin" element={<AdminDashboard />} />
            <Route path="profile" element={<UserProfile />} />
            <Route path="register" element={<RegisterPage />} />
            <Route path="login" element={<LoginPage />} />
            <Route path="customizeCake" element={<CustomizeCake />} />
            <Route path="/confirm" element={<ConfirmPage />} />
            <Route path="cake/:id" element={<Cake />} />
          </Route>
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
